import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { nonEmpty } from "@swo/shared";
import { TimeAgoFormat } from "./PDPReviewsDetailsReviewsListElement";

export const getReviewDateAgoLabel =
  (now: Date, locale: SwarovskiOptikLocaleFrontend) => (createdDateIsoString: string) => {
    function getDaysAgo(dateIsoString: string) {
      const date = new Date(dateIsoString);

      const days = (now.getTime() - date.getTime()) / 1000 / 60 / 60 / 24;

      return days;
    }

    function formatAgo(daysAgo: number): TimeAgoFormat {
      if (daysAgo > 365) {
        return { tag: "years", value: Math.floor(daysAgo / 365) };
      } else if (daysAgo > 30) {
        return { tag: "months", value: Math.floor(daysAgo / 30) };
      } else if (daysAgo > 7) {
        return { tag: "weeks", value: Math.floor(daysAgo / 7) };
      } else {
        if (daysAgo > 1) {
          return { tag: "days", value: Math.floor(daysAgo) };
        } else {
          return { tag: "day", value: 0 };
        }
      }
    }

    const locales = [
      locale.country === "INTERNATIONAL" ? undefined : locale.country.isoCode,
      locale.language.isoCode,
      "en",
    ]
      .filter(nonEmpty)
      .map(t => t.toLowerCase());

    const rtf = new Intl.RelativeTimeFormat(locales, { numeric: "auto" });

    const ego = formatAgo(getDaysAgo(createdDateIsoString));

    return rtf.format(-ego.value, ego.tag);
  };
